const CACHE = 'peasents.photon.v1';

/** Shipped with the game. Friends never type this. */
export const BUNDLED_PHOTON_APP_ID = '65b5edda-9280-47fd-b884-df0a07baf1a5';

export function rememberPhotonAppId(id: string): void {
  const trimmed = id.trim();
  if (trimmed) localStorage.setItem(CACHE, trimmed);
}

/**
 * The App Id is public. The game reads it once from the build or from
 * photon.json, then keeps it on the device.
 */
export async function resolvePhotonAppId(): Promise<string> {
  const cached = localStorage.getItem(CACHE)?.trim() || '';
  if (cached) return cached;
  const built = (import.meta.env.VITE_PHOTON_APP_ID || BUNDLED_PHOTON_APP_ID).trim();
  if (built) {
    rememberPhotonAppId(built);
    return built;
  }
  try {
    const res = await fetch(new URL('photon.json', document.baseURI));
    if (!res.ok) return '';
    const data = (await res.json()) as { appId?: string };
    const id = (data.appId || '').trim();
    if (!id) return '';
    rememberPhotonAppId(id);
    return id;
  } catch {
    return '';
  }
}
